import React from 'react';
import {
  AUTH_PATH_PREFIX,
  APP_PATH_PREFIX,
  PUBLIC_PATH_PREFIX,
} from './AppConfig';

// Auth routes - redirect to home if already authenticated
export const authRoutes = [
  {
    key: 'login',
    path: `${AUTH_PATH_PREFIX}/login`,
    component: React.lazy(() => import('../views/auth-views/login')),
  },
  {
    key: 'forgot-password',
    path: `${AUTH_PATH_PREFIX}/forgot-password`,
    component: React.lazy(() => import('../views/auth-views/forgot-password')),
  },
];

// Public routes - accessible to everyone (authenticated or not)
export const publicRoutes = [
  {
    key: 'public-page',
    path: `${PUBLIC_PATH_PREFIX}/vendorForm`,
    component: React.lazy(() => import('../views/public-views/VendorForm.js')),
  },
  {
    key: 'RM Master',
    path: `${PUBLIC_PATH_PREFIX}/rm-master`,
    component: React.lazy(() => import('../views/app-views/Rm-Master')),
  },
];
export const protectedRoutes = [
  {
    key: 'home',
    path: `${APP_PATH_PREFIX}/home`,
    component: React.lazy(() => import('../views/app-views/home')),
  },
  {
    key: 'change-password',
    path: `${APP_PATH_PREFIX}/change-password`,
    component: React.lazy(() => import('../views/auth-views/change-password')),
  },
  {
    key: 'profile',
    path: `${APP_PATH_PREFIX}/profile`,
    component: React.lazy(() => import('../views/app-views/profile')),
  },
  {
    key: 'USER',
    path: `${APP_PATH_PREFIX}/manage-user`,
    component: React.lazy(() => import('../views/app-views/user')),
  },
  {
    key: 'role',
    path: `${APP_PATH_PREFIX}/role`,
    component: React.lazy(() => import('../views/app-views/roles')),
  },
  //----------------PURCHASE ORDER ROUTES---------------------------------------------------------------------------
  {
    key: 'My Purchase Order',
    path: `${APP_PATH_PREFIX}/my-purchase-orders`,
    component: React.lazy(() => import('../views/app-views/purchase-orders')),
  },
  // ---------------CORE ROUTES-----------------------------------------------------------------
  {
    key: 'create-invoice', //Core Create Invoice Component
    path: `${APP_PATH_PREFIX}/create-invoice`,
    component: React.lazy(() =>
      import('../views/app-views/Components/createInvoice')
    ),
  },
  {
    key: 'view-invoice', //Core View Invoice Component
    path: `${APP_PATH_PREFIX}/view-invoice/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/Components/invoiceDetails')
    ),
  },
  {
    key: 'edit-invoice', //Core Edit Invoice Component
    path: `${APP_PATH_PREFIX}/edit-invoice/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/Components/editInvoice')
    ),
  },
  //---------------VENDOR ROUTES------------------------------------------------------------
  {
    key: 'Vendor Dashboard',
    path: `${APP_PATH_PREFIX}/vendor-dashboard`,
    component: React.lazy(() =>
      import('../views/app-views/vendor/dashboard/VendorDashboard')
    ),
  },
  {
    key: 'vendor-invoices',
    path: `${APP_PATH_PREFIX}/vendor-invoices`,
    component: React.lazy(() => import('../views/app-views/vendor')),
  },
  {
    key: 'VVENI', //view-vendor-invoice
    path: `${APP_PATH_PREFIX}/VVENI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/vendor/ViewVendorWrapper')
    ),
  },
  {
    key: 'EVENI', //edit-vendor-invoice
    path: `${APP_PATH_PREFIX}/EVENI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/vendor/EditVendorWrapper')
    ),
  },
  //---------------SECURITY ROUTES----------------------------------------------------------------------------
  {
    key: 'Security',
    path: `${APP_PATH_PREFIX}/security`,
    component: React.lazy(() => import('../views/app-views/security')),
  },
  {
    key: 'VSECI', //view-security-invoice
    path: `${APP_PATH_PREFIX}/VSECI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/security/ViewSecurityWrapper')
    ),
  },
  {
    key: 'ESECI', //edit-security-invoice
    path: `${APP_PATH_PREFIX}/ESECI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/security/EditSecurityWrapper')
    ),
    //---------------STORE ROUTES----------------------------------------------------------------------------
  },
  {
    key: 'Store',
    path: `${APP_PATH_PREFIX}/store`,
    component: React.lazy(() => import('../views/app-views/store')),
  },
  {
    key: 'VGRNI', //view-Store-invoice
    path: `${APP_PATH_PREFIX}/VGRNI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/store/ViewStoreWrapper')
    ),
  },
  {
    key: 'EGRNI', //edit-Store-invoice
    path: `${APP_PATH_PREFIX}/EGRNI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/store/EditStoreWrapper')
    ),
  },
  //---------------FINANCE ROUTES----------------------------------------------------------------------------
  {
    key: 'Finance',
    path: `${APP_PATH_PREFIX}/finance`,
    component: React.lazy(() => import('../views/app-views/finance')),
  },
  {
    key: 'Quality Approve',
    path: `${APP_PATH_PREFIX}/quality-approve`,
    component: React.lazy(() =>
      import('../views/app-views/finance/approve/FinanceApprove')
    ),
  },
  {
    key: 'VAFINRI', //view-Finance-invoice
    path: `${APP_PATH_PREFIX}/VAFINRI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/finance/approve/ViewApproveWrapper')
    ),
  },
  {
    key: 'EAFINRI', //edit-Finance-invoice
    path: `${APP_PATH_PREFIX}/EAFINRI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/finance/approve/EditApproveWrapper')
    ),
  },
  {
    key: 'Review_Finance',
    path: `${APP_PATH_PREFIX}/finance/finance-review`,
    component: React.lazy(() =>
      import('../views/app-views/finance/review/FinanceReview')
    ),
  },
  {
    key: 'VRFINWI', //view-Finance-invoice
    path: `${APP_PATH_PREFIX}/VRFINWI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/finance/review/ViewReviewWrapper')
    ),
  },
  {
    key: 'ERFINWI', //edit-Finance-invoice
    path: `${APP_PATH_PREFIX}/ERFINWI/:_id`,
    component: React.lazy(() =>
      import('../views/app-views/finance/review/EditReviewWrapper')
    ),
  },
  // -------------PLI Application-----------------------------------------------
  {
    key: 'PLI-Imports',
    path: `${APP_PATH_PREFIX}/pli-imports`,
    component: React.lazy(() => import('../views/app-views/Pli-Imports')),
  },
  {
    key: 'PLI-Purchase',
    path: `${APP_PATH_PREFIX}/pli-purchase`,
    component: React.lazy(() => import('../views/app-views/PLI-Purchase')),
  },
  {
    key: 'PLI-Finance',
    path: `${APP_PATH_PREFIX}/pli-finance`,
    component: React.lazy(() => import('../views/app-views/PLI-Finance')),
  },
  {
    key: 'Manage Vendor', //
    path: `${APP_PATH_PREFIX}/vendor-master`,
    component: React.lazy(() => import('../views/app-views/vendor-master')),
  },
  // -------------------------Quotation Logging-------------------------
  {
    key: 'Quotes', //
    path: `${APP_PATH_PREFIX}/quotes`,
    component: React.lazy(() => import('../views/app-views/Quotes')),
  },
  {
    key: 'My Quotes', //
    path: `${APP_PATH_PREFIX}/quotes/my-quotes`,
    component: React.lazy(() => import('../views/app-views/Quotes')),
  },
  {
    key: 'Quotes Dashboard',
    path: `${APP_PATH_PREFIX}/quotes-dashboard`,
    component: React.lazy(() => import('../views/app-views/QuoteDashboard')),
  },
  // --------------------------In-App Admin Screen--------------------------
  {
    key: 'Manage-Users',
    path: `${APP_PATH_PREFIX}/manage-users`,
    component: React.lazy(() => import('../views/app-views/ManageUsers')),
  },
  {
    key: 'Manage-Programs',
    path: `${APP_PATH_PREFIX}/manage-programs`,
    component: React.lazy(() => import('../views/app-views/Manage-Programs')),
  },
  // --------------------------RM Indexing--------------------------
  {
    key: 'RM/BOP Master',
    path: `${APP_PATH_PREFIX}/rm-master`,
    component: React.lazy(() => import('../views/app-views/Rm-Master')),
  },
  {
    key: 'FG Master',
    path: `${APP_PATH_PREFIX}/fg-master`,
    component: React.lazy(() => import('../views/app-views/Fg-Master')),
  },
  {
    key: 'Price Revision',
    path: `${APP_PATH_PREFIX}/price-revision`,
    component: React.lazy(() => import('../views/app-views/Price-Revision')),
  },
  {
    key: 'Baseline PO',
    path: `${APP_PATH_PREFIX}/baseline-po`,
    component: React.lazy(() => import('../views/app-views/Amendment-Master')),
  },
  // --------------------------RMI Suppliers--------------------------
  {
    key: 'Impacted Program List',
    path: `${APP_PATH_PREFIX}/rmi-suppliers/impacted-programs`,
    component: React.lazy(() =>
      import('../views/app-views/rmi-suppliers/impacted-program-list')
    ),
  },
  {
    key: 'Supplier Master',
    path: `${APP_PATH_PREFIX}/rmi-suppliers/supplier-master`,
    component: React.lazy(() =>
      import('../views/app-views/rmi-suppliers/supplier-master')
    ),
  },
  {
    key: 'Norms Master',
    path: `${APP_PATH_PREFIX}/rmi-suppliers/norms-master`,
    component: React.lazy(() =>
      import('../views/app-views/rmi-suppliers/norms-master')
    ),
  },
  {
    key: 'Part Cost Master',
    path: `${APP_PATH_PREFIX}/rmi-suppliers/part-cost-master`,
    component: React.lazy(() =>
      import('../views/app-views/rmi-suppliers/part-cost-master')
    ),
  },
  {
    key: 'Pass Through',
    path: `${APP_PATH_PREFIX}/rmi-suppliers/pass-through/:runId?`,
    component: React.lazy(() =>
      import('../views/app-views/rmi-suppliers/pass-through')
    ),
  },
  {
    key: 'Tracking Report',
    path: `${APP_PATH_PREFIX}/rmi-suppliers/reports/po-tracking`,
    component: React.lazy(() =>
      import('../views/app-views/rmi-suppliers/reports/po-tracking/index.js')
    ),
  },
];
